<template>
  <div
    class="product-swiper"
    :class="{
      'product-swiper--show-nav': showNavButton,
    }"
  >
    <!-- 产品标签 -->
    <v-product-tag
      v-if="isProduct && $store.state.product_tag_list[productRes.ID]"
      :productTag="$store.state.product_tag_list[productRes.ID]"
      :productInfo="productInfo"
      class="product-swiper__tag"
    />

    <!-- 图片切换 -->
    <swiper
      ref="mySwiper"
      class="swiper swiper-container"
      :options="swiperOptions"
      @slideChange="slideChange"
      :class="{ 'swiper-no-swiping': gallery.length <= 1 }"
    >
      <swiper-slide class="product-swiper__slide" v-for="item in gallery" :key="item.ID" style="text-align: center">
        <div
          class="product-swiper__slide-card"
          v-if="picZoom && (item.media_content_type == 'image' || item.media_content_type == 'external_image')"
        >
          <v-picZoom :url="item.url" :bigUrl="item.url" :appendToBody="true" />
        </div>
        <v-media-card
          v-else
          :type="item.media_content_type"
          :src="item.url"
          :url="item.url"
          :thumbnail="item.thumbnail"
          :autoplay="false"
          :show-play-button="false"
          :muted="true"
          class="product-swiper__slide-card"
          @imageLoad="handleImageLoad"
        />
      </swiper-slide>

      <!-- 点状分页, 移动端显示 -->
      <div
        class="product-swiper__dot-pagination swiper-pagination swiper-no-swiping pg-inline d-block d-md-none"
        slot="pagination"
        v-if="gallery.length > 1"
      />

      <!-- 左右导航 -->
      <template v-if="showNavButton">
        <div class="swiper-button-prev iconfont pswp-prev" slot="button-prev" v-if="gallery.length > 1">
          <slot name="prev"> &#xe691; </slot>
        </div>
        <div class="swiper-button-next iconfont pswp-next" slot="button-next" v-if="gallery.length > 1">
          <slot name="next"> &#xe609; </slot>
        </div>
      </template>
    </swiper>

    <!-- 图片分页，移动端隐藏 -->
    <div class="product-swiper__pagination d-none d-md-block" v-if="paginationStyle && gallery.length > 1">
      <!-- 罗列分页 -->
      <div class="swiper-pagination__list" v-if="paginationStyle === 'list'">
        <span
          class="swiper-pagination__item"
          v-for="(item, index) in gallery"
          :key="item.ID"
          :class="{
            active: swiperIndex === index,
          }"
          @click="() => selectSwiper(index)"
        >
          <div class="swiper-pagination__img-wrapper">
            <i
              v-if="item.media_content_type === 'external_video' || item.media_content_type === 'video'"
              class="swiper-pagination__video-icon"
              :class="{
                'iconfont icon-cm-youtube': item.media_content_type === 'external_video',
                'el-icon-video-play': item.media_content_type === 'video',
              }"
            />
            <v-lazy-img :src="item.thumbnail" :data-src="item.thumbnail" :data-url="item.url" />
          </div>
        </span>
      </div>

      <!-- 横版分页 -->
      <v-pageination
        v-else
        :gallery="gallery"
        :currentIndex="swiperIndex"
      ></v-pageination>
    </div>
  </div>
</template>

<script>
import { playVideo } from '@/js/lib/util'
import VideoPlayerVue from '@/js/components/VideoPlayer.vue'
import vPageination from './pageination.vue'
import vProductTag from '@/js/components/view/productTag/productTag.vue'
import MediaCard from '@/js/components/MediaCard.vue'
//import LazyImg from '@/js/components/LazyImg.vue'
import vPicZoom from '@/js/components/common/picZoom.vue'

export default {
  components: {
    [MediaCard.name]: MediaCard,
    [VideoPlayerVue.name]: VideoPlayerVue,
    vPageination,
    vProductTag,
    //LazyImg,
    vPicZoom
  },
  props: [
    'gallery', // 切换的图片
    'picZoom', // 放大镜功能
    'paginationStyle', // 分页类型，list，inline 或 null
    'productRes',
    'isProduct',
    'option', // swiper配置
    'swiper_index',
    'showNavButton', // 是否展示导航箭头按钮，就是向左向右按钮
    'productInfo',
  ],
  data() {
    const swiperEvent = {
      // 切换结束
      slideChangeTransitionEnd: this.handChangeEnd,
    }

    const defaultOption = {
      autoHeight: true, //enable auto height
      pagination: {
        el: '.product-swiper__dot-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      loop: true,
      noSwiping: true,
      noSwipingClass: 'swiper-no-swiping',
    }

    const option = this.option || defaultOption

    return {
      // defaultImage,
      swiperOptions: {
        ...option,
        on: swiperEvent,
      },
      el: null,
      swiperIndex: 0, // 从0开始，swiper的index是从1开始
    }
  },
  methods: {
    // 图片加载结束
    handleImageLoad() {
      // 更新下高度
      this.swiper?.updateAutoHeight()
    },
    /**
     * 滚动
     */
    slideChange() {
      const { realIndex, activeIndex } = this.swiper
      if (this.swiper_index) {
        this.swiper_index.activeIndex = this.swiper.realIndex
      }

      this.swiperIndex = activeIndex - 1

      const videoDom = this.el && Jq(this.el)?.find('.swiper-slide-active [video-src]')?.[0]
      if (!videoDom) return

      playVideo(videoDom, 0)
    },
    // 结束切换
    handChangeEnd(a) {
      const videoDom = this.el && Jq(this.el)?.find('.swiper-slide-active [video-src]')?.[0]
      if (!videoDom) return
      playVideo(videoDom, 1)
    },
    /**
     * 切换swiper
     */
    selectSwiper(index) {
      this.swiper.slideTo(index + 1)
      this.swiperIndex = index
    },
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    },
  },
  mounted() {
    const dom = this.$refs.mySwiper?.swiper?.el

    this.el = dom
    // 先关闭已经正在播放的视频如果有的话
    const videoDom = Jq('.product-swiper .swiper-slide.swiper-slide-active [video-src]')

    if (videoDom && videoDom.length > 0) {
      for (let i = 0; i < videoDom.length; i++) {
        playVideo(videoDom[i], 0)
      }
    }

    // 当前可能是视频需要播放
    const thisVideoDom = dom && Jq(dom)?.find('.swiper-slide-active [video-src]')?.[0]

    if (thisVideoDom) playVideo(thisVideoDom, 1)
  },
  watch: {
    // 监听全局状态的图片变化，跳转到指定的index
    '$store.state.feature_image_id'() {
      this.gallery.some((item, index) => {
        if (item.ID == this.$store.state.feature_image_id) {
          this.swiper.slideTo(index + 1)
        }
      })
    },
  },
}
</script>
<style lang='scss' scoped>
.product-swiper {
  max-width: 100vw;
  position: relative;
  // 轮播图
  margin-bottom: 60px;
  &--show-nav {
    .product-swiper {
      &__slide-card,
      &__tag {
        width: calc(90% - 96px);
        display: inline-block;
      }
      &__tag {
        left: calc(5% + 48px);
      }
      &__slide-card {
        &::v-deep {
          .v-media-card__media {
            img {
              width: 100%;
            }
          }
        }
      }
    }
    &::v-deep {
      .swiper {
        .swiper-button-prev,
        .swiper-button-next {
          background-image: none;
          font-size: 34px;
          color: #ababab;
          font-weight: 100;
          height: 44px;
          line-height: 44px;
        }
      }
    }
  }
  &__pagination {
    margin-top: 20px;
    .swiper-pagination {
      &__list {
        margin-left: -6px;
        margin-right: -6px;
        text-align: center;
      }
      &__item {
        display: inline-block;
        padding-left: 6px;
        padding-right: 6px;
        padding-top: 3px;
        padding-bottom: 3px;
        &.active {
          .swiper-pagination {
            &__img-wrapper {
              &::before {
                border: 2px solid var(--main-btn-bg);
              }
            }
          }
        }
      }
      &__img-wrapper {
        height: 50px;
        width: 50px;
        cursor: pointer;
        position: relative;
        background-color: #dedede5d;
        &::before {
          height: 100%;
          width: 100%;
          position: absolute;
          top: 0;
          content: '';
          z-index: 2;
        }
        img {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }
      }
      &__video-icon {
        position: absolute;
        z-index: 2;
        font-size: 18px;
        color: #fff;
        height: 100%;
        width: 100%;
        background: #00000035;
        top: 0;
        left: 0;
        &::before {
          position: absolute;
          right: 6px;
          bottom: 6px;
        }
      }
    }
  }

  // @media screen and (max-width: 980px) {
  //   margin-bottom: 0;
  //   &::v-deep {
  //     .tag {
  //       // width: 100% !important;
  //       max-width: 500px !important;
  //       // left: 0 !important;
  //     }
  //     .swiper {
  //       .swiper-wrapper {
  //         .swiper-slide {
  //           img {
  //             width: 100%;
  //             max-width: 500px;
  //           }
  //         }
  //       }
  //       .swiper-button-prev,
  //       .swiper-button-next {
  //         display: none;
  //       }
  //     }
  //   }
  // }
  @media screen and (max-width: 767px) {
    margin-bottom: 0;
    &__slide-card,
    &__tag {
      width: 100%;
    }
    &__slide-card {
      ::v-deep {
        img {
          width: 100%;
        }
      }
    }
    &__tag {
      left: 0;
    }
    &--show-nav {
      .product-swiper {
        &__slide-card,
        &__tag {
          width: 100%;
        }
        &__tag {
          left: 0;
        }
      }
      &::v-deep {
        .swiper {
          .swiper-button-prev,
          .swiper-button-next {
            display: none;
          }
        }
      }
    }
    &__dot-pagination {
      &::v-deep {
        .tag {
          width: 100% !important;
          left: 0 !important;
        }
        .swiper-pagination-bullet {
          width: 12px;
          height: 12px;
          background-color: #999;
          border-color: transparent;
        }
        .swiper-pagination-bullet-active {
          background-color: #555;
        }
      }
    }
  }
}
</style>
